import React, { useState } from 'react';
import { useEffect } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import { PaperClipOutlined } from '@ant-design/icons';
import { Button, Drawer, message, Popconfirm, Spin, Table } from 'antd';

import '../../CRM/Antd.css';
import Configurazione from '../../Configurazione';
import sessionManager, { eVariableType } from '../../SessionManager';
import { GetFormattedData } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import '../Generic.css';
import OpportunitaScheda from './OpportunitaScheda';

export default function OpportunitaGrid(props) {
    const configurazione = Configurazione();
    const { filtro } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(configurazione.maxResultsPerPage);
    const [totalPages, setTotalPages] = useState(1);
    const [reload, setReload] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentRow, SetCurrentRow] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                setIsLoading(true);

                const flt = filtro != null || filtro === undefined ? filtro : '';
                const request = {
                    idSocieta: sessionManager.get(eVariableType.IDSocieta),
                    ragioneSociale: flt,
                };

                const result = await api.post('CRM/Opportunita', request);

                if (result != null && result.data != null) {
                    setData(result.data);
                }
            } catch (error) {
                message.error(error.message);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, [props, currentPage, reload]);

    //#region Grid data

    const columns = [
        { title: stringres.t('ragioneSociale'), dataIndex: 'ragioneSociale' },
        {
            title: stringres.t('oggetto'),
            dataIndex: 'oggetto',
            render: (text, record) => (
                <button className="link-button" onClick={() => showModal(record)}>
                    {text}
                </button>
            ),
        },
        { title: 'Descrizione', dataIndex: 'descrizione' },
        { title: 'Tipo', dataIndex: 'statoOpportunita' },
        { title: 'Tipo', dataIndex: 'tipologiaOpportunita' },
        { title: 'Importo', dataIndex: 'importoPrevisto' },
        {
            title: 'Prev.Chiusura',
            dataIndex: 'dataPrevistaChiusura',
            render: (text) => (
                <span>
                    <GetFormattedData data={text}></GetFormattedData>
                </span>
            ),
        },
        { title: 'Attivita', dataIndex: 'oggettoAttivita' },
        {
            title: 'Data prev.',
            dataIndex: 'dataOraPrevistaAttivita',
            render: (text) => (
                <span>
                    <GetFormattedData data={text}></GetFormattedData>
                </span>
            ),
        },
        {
            title: '',
            dataIndex: 'idAllegato',
            render: (text, record) => {
                <div>
                    record.idAllegato === 0 ? <Button icon={<PaperClipOutlined />}></Button>: null
                </div>;
            },
        },
        {
            title: '',
            dataIndex: 'delete',
            render: (text, record) => (
                <Popconfirm
                    title={stringres.t('elimina').toString()}
                    description={stringres.t('eliminare?').toString()}
                    onConfirm={() => onDelete(record)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button>
                        <DeleteOutlined />
                    </Button>
                </Popconfirm>
            ),
        },
    ];

    //#endregion

    //#region "Eventi griglia"
    async function onDelete(rec) {
        try {
            setIsLoading(true);
            if (rec != null) {
                const result = await api.delete(
                    'CRM/Opportunita/Delete?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&idOpportunita=' +
                        rec.idOpportunita
                );
                if (result.status === 200) {
                    message.success(stringres.t('successo'));

                    setReload(!reload);
                } else message.error(result.statusText);
            }
        } catch (error) {
            message.error(error.response.data.message, 5);
        } finally {
            setIsLoading(false);
        }
    }

    const showModal = (record) => {
        SetCurrentRow(record);
        setIsModalOpen(true);
    };

    const onChange = (pagination, filters, sorter, extra) => {};
    const handlePageChange = (page, pSize) => {
        setCurrentPage(page);
        setPageSize(pSize);
        if (data != null && data.length > 0) setTotalPages(Math.floor(data[0].totaleRighe / pSize));
    };
    const handlePageSizeChange = (current, size) => {
        setPageSize(size);
        setCurrentPage(1);
    };
    const pagination = {
        current: currentPage,
        pageSize: pageSize,
        total: totalPages * pageSize,
        onChange: handlePageChange,
        onShowSizeChange: handlePageSizeChange,
    };

    //#endregion

    return (
        <div>
            <Spin spinning={isLoading} size="large">
                <Table
                    rowKey="idOpportunita"
                    columns={columns}
                    dataSource={data}
                    pagination={pagination}
                    onChange={onChange}
                ></Table>
            </Spin>
            <Drawer
                destroyOnClose={true}
                open={isModalOpen}
                title={
                    <span style={{ fontSize: '22px' }}>
                        {stringres.t('opportunitaAttivita') +
                            ': ' +
                            currentRow?.ragioneSociale +
                            ' - ' +
                            currentRow?.oggetto}
                    </span>
                }
                onClose={() => setIsModalOpen(false)}
                style={{ backgroundColor: '#eef2f4' }}
                width={'90%'}
            >
                <OpportunitaScheda idOpportunita={currentRow?.idOpportunita}></OpportunitaScheda>
            </Drawer>
        </div>
    );
}
